import {item} from './item';

export const query = `query getProductById($productId: String!, $withOptions: Boolean = true, $withPriceRange: Boolean = false) {
  catalog {
    product(productId: $productId) {
      ${item}
    }
  }
}
`;
